import React from "react";

import Navbar from "./components/Navbar";
import Header from "./components/Header";
import {Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import Other from "./pages/Other";
import Finance from "./pages/Finance";
import ExternalSector from "./pages/ExternalSector";
import Schedule from "./pages/Schedule";
import Footer from "./components/Footer";
import 'react-calendar/dist/Calendar.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import 'jstree/dist/themes/default/style.css';
import ReactGA from "react-ga4";
import MoneyMarket from "./pages/MoneyMarket";

ReactGA.initialize("G-K3CPXMN9GE");

const App = () => {

    return (
        <>
            <div className="flex flex-col h-screen justify-between select-none" id="root">
                <Header></Header>
                <Navbar></Navbar>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/bulletin" element={<Home param={"bulletin"}/>}/>
                    <Route path="/finance" element={<Finance/>}/>
                    <Route path="/external" element={<ExternalSector/>}/>
                    <Route path="/moneymarket" element={<MoneyMarket/>}/>
                    <Route path="/other" element={<Other/>}/>
                    <Route path="/schedule" element={<Schedule/>}/>
                </Routes>
                <Footer></Footer>
            </div>
        </>
    );
};

export default App;